/* global fetch */
import Cookies from 'js-cookie';

import { FETCH_ACCOUNT_DETAILS_FULFILLED, requestFetchProductWithSkus } from '../actions';
import { FETCH_SPONSORED_BRANDS_FULFILLED, getSponsoredBrandsCreator } from '../actions/sponsoredBrands';
import { getEveApiAccessToken, getEveApiUrl } from '../selectors';
import { handleBadResponse } from './fetchJson';
import { getSponsoredBrandProductsSlices } from '../selectors/sponsoredBrands';

const fetchSponsoredBrands = async (
  url,
  token,
  segment,
  syntheticId,
) => {
  const authorizationHeader = token ? { Authorization: `Bearer ${token}` } : {};
  const query = segment ? `?segment=${segment}` : '';

  const response = await fetch(`${url}/sponsored-product/brand${query}`, {
    method: 'GET',
    headers: {
      ...authorizationHeader,
      'Content-Type': 'application/json',
      'X-Synthetic-Id': syntheticId,
    },
  });

  if (!response.ok) {
    await handleBadResponse(response, `Failed fetch sponsored brands: ${response.statusText}`);
  }

  const responseBody = await response.json();
  // eslint-disable-next-line no-underscore-dangle
  return responseBody?._embedded?.brands || [];
};

const dispatchFetchSponsoredBrands = store => {
  const state = store.getState();

  const sponsoredBrandSlices = getSponsoredBrandProductsSlices(state);
  if (!sponsoredBrandSlices.length) {
    return;
  }

  const apiUrl = getEveApiUrl(state);
  const token = getEveApiAccessToken(state);
  // In Prismic, Sponsored_Brand_Products can have different segment.
  //  but we only handle the first segment.
  const { segment } = sponsoredBrandSlices[0];
  const syntheticId = Cookies.get('_ticid');

  store.dispatch(getSponsoredBrandsCreator(
    segment,
    fetchSponsoredBrands(apiUrl, token, segment, syntheticId),
  ));
};

const dispatchFetchProducts = (store, action) => {
  const state = store.getState();
  const slices = getSponsoredBrandProductsSlices(state);
  slices.forEach(({ sliceId }, index) => {
    const products = action.payload?.[index]?.products || [];
    store.dispatch(requestFetchProductWithSkus(sliceId, products, true));
  });
};

export default store => next => action => {
  const ret = next(action);
  switch (action.type) {
    // DEV NOTE: Token is available after fetching account detail
    case FETCH_ACCOUNT_DETAILS_FULFILLED:
      return dispatchFetchSponsoredBrands(store);
    case FETCH_SPONSORED_BRANDS_FULFILLED:
      // DEV NOTE: Sponsored brands are returned with product skus only.
      // Hook to fetch products details.
      return dispatchFetchProducts(store, action);
    // no default
  }
  return ret;
};
